<div class="modal-container">
    <div class=" header-container">
      <div >{{ configs[currentMode].title }}</div>
      <button *ngIf="currentMode === FormMode.EDIT" type="button" [disabled]="isVerified" (click)="resendInvite()"
              [ngClass]="{'resend-button': true, 'disabled': isVerified }">
        Resend Invite
      </button>
    </div>
    <div class="form-container">
        <app-titled-input [control]="firstName" [title]="'First name'">
            <ng-content>
                <input class="'modal-input'" type="text" [formControl]="firstName">
            </ng-content>
        </app-titled-input>
        <app-titled-input [control]="lastName" [title]="'Last name'">
            <ng-content>
                <input type="text" [formControl]="lastName">
            </ng-content>
        </app-titled-input>
        <app-titled-input [control]="email" [title]="'Email'">
            <ng-content>
                <input type="text" [formControl]="email">
            </ng-content>
        </app-titled-input>
        <app-titled-input [control]="role" [title]="'Role'">
            <ng-content>
                <app-select-menu [items]="rolesOptions" [placeholder]="'Select role'" [control]="role" [searchable]="false" [selectMode]="SelectMode.SINGLE"></app-select-menu>
            </ng-content>
        </app-titled-input>
      <div class="select-menu-input-wrapper">
        <app-titled-input [control]="accountKey" [title]="'Account'">
        </app-titled-input>
        <app-select-menu [items]="accountOptions" [placeholder]="'Select account'" [control]="accountKey"
                           [selectMode]="SelectMode.SINGLE" [searchable] =true></app-select-menu>
      </div>
    </div>
    <div class="buttons-container">
        <app-button *ngIf="currentMode === FormMode.EDIT && canDelete" (clicked)="deleteUser()" class="danger delete-user-button" text="Delete user"></app-button>
        <app-button (clicked)="cancel()" class="cancel" text="cancel"></app-button>
        <app-button (clicked)="submit()" [class]="form.invalid? 'primary disabled' : 'primary'" [text]="configs[currentMode].submitText"></app-button>
    </div>
</div>
